module.exports = __webpack_public_path__ + "static/media/occupancy.0ee7132d.svg";